import React from 'react';
import AnnourFooter from '../BeforeLoginPages/AnnourFooter';
import arduinoImage1 from '../../imgs/arduino1.jpg';
import arduinoImage0 from '../../imgs/arduino0.jpg';
import scratchImage from '../../imgs/scratch0.jpg';
import kidsImage from '../../imgs/kids0.jpg';

const ProgrammingCoursesPage = () => {
  const upcomingCourses = [
    {
      title: 'ZURZEIT FINDET KEINE NEUEN KURSE STATT.',
      isAvailable: false,
    },
  ];

  const courseSections = [
    {
      title: 'FiBS – Ferien in Braunschweig',
      courses: {
        2024: [
          {
            title:
              'Elektronik für Kinder: Arduino programmieren und Mikrocontroller am 08.07.2024',
            url: 'https://www.unser-ferienprogramm.de/braunschweig/veranstaltung.php?v=50387&id=204130',
          },
          {
            title:
              'Programmierkurs für Kinder: mit der Programmiersprache Scratch von 09.07.2024 bis 10.07.2024',
            url: 'https://www.unser-ferienprogramm.de/braunschweig/veranstaltung.php?v=50387&id=204117',
          },
          {
            title:
              'Programmierkurs für Kinder: mit der Programmiersprache Scratch von 11.07.2024 bis 12.07.2024',
            url: 'https://www.unser-ferienprogramm.de/braunschweig/veranstaltung.php?v=50387&id=204127',
          },
          {
            title:
              'Programmierkurs für Kinder: mit Scratch einen Roboter programmieren am 07.10.2024',
            url: 'https://www.unser-ferienprogramm.de/braunschweig/veranstaltung.php?v=50387&id=204127',
          },
        ],
      },
    },
    {
      title: 'Büro für Migrationsfragen',
      courses: {
        2022: [
          {
            title: '2022: Training Java-Programmierung',
          },
        ],
        2021: [
          {
            title: 'PC Grundlage und Libre Office Training',
          },
          {
            title: 'Training Java-Programmierung',
          },
        ],
      },
    },
    {
      title: 'Meet And Code',
      courses: {
        2024: [
          {
            title: 'Elektronik: Arduino programmieren',
            url: 'https://www.meet-and-code.org/de/de/event-show/12624',
          },
          {
            title: 'Mit Scratch einen Roboter programmieren für Kids',
            url: 'https://www.meet-and-code.org/de/de/event-show/12538',
          },
        ],
        2023: [
          {
            title: 'Python Grundlagen',
            url: 'https://meet-and-code.org/de/de/event-show/10227',
          },
          {
            title: 'Einführung in Scratch für Kids',
            url: 'https://meet-and-code.org/de/de/event-show/10570',
          },
          {
            title: 'Roboter Programmieren mit Python',
            url: 'https://meet-and-code.org/de/de/event-show/10373',
          },
        ],
        2022: [
          {
            title: 'Python für Kids',
            url: 'https://meet-and-code.org/de/de/event-show/9266',
          },
          {
            title: 'Programmieren mit Scratch für Kids',
            url: 'https://www.meet-and-code.org/de/de/event-show/9272',
          },
        ],
        2021: [
          {
            title: 'PC Grundlage und Libre Office Training',
            url: 'https://meet-and-code.org/de/de/event-show/7765',
          },
          {
            title: 'Training Java-Programmierung',
            url: 'https://meet-and-code.org/de/de/event-show/7744',
          },
        ],
      },
    },
  ];

  return (
    <div className="min-h-screen pt-12 px-4 sm:px-6 lg:px-8 bg-gradient-to-b from-blue-50 to-white">
      <div className="max-w-6xl mx-auto bg-white/90 backdrop-blur-sm p-8 shadow-2xl rounded-xl border border-blue-100">
        <h1 className="text-3xl md:text-4xl font-extrabold text-main mb-8 relative">
          <span className="relative inline-block">
            Programmierkurse
            <div className="absolute bottom-0 left-0 w-full h-1 bg-blue-500 transform origin-left scale-x-100"></div>
          </span>
        </h1>

        <p className="text-gray-700 text-base md:text-lg mb-6 leading-relaxed">
          Unsere Programmierkurse verfolgen das Ziel, die Kinder im
          Bereich Informatik zu fördern und sie auf dieses Fach in der
          Schule vorzubereiten. In der Vergangenheit konnten wir
          Erfolge und die Vorteile unserer Kurse bei Schülern
          beobachten. Wir haben Kurse in folgenden Sprachen angeboten:
        </p>
        <ul className="list-disc list-inside text-gray-700 text-base md:text-lg mb-6">
          <li>
            Block Programmiersprache Scratch (Programmierung vom mBot2
            Roboter)
          </li>
          <li>Python</li>
          <li>Java</li>
        </ul>
        <p className="text-gray-700 text-base md:text-lg mb-10">
          Die Kurse wurden von Ingenieuren und Studenten/Schülern
          betreut.
        </p>

        {/* Neue Kurse */}
        <section className="mb-10">
          <h2 className="text-2xl font-semibold text-gray-800 mb-4 flex items-center gap-2">
            <span className="text-3xl">📅</span> Neue Kurse
          </h2>
          <div className="bg-white p-6 rounded-xl shadow-lg border border-blue-50">
            <ul className="list-disc list-inside space-y-2">
              {upcomingCourses.map((course, index) => (
                <li
                  key={index}
                  className={`transition-all duration-200 ${
                    course.isAvailable
                      ? 'text-blue-600 hover:text-blue-700'
                      : 'italic text-gray-500'
                  }`}
                >
                  {course.title}
                </li>
              ))}
            </ul>
          </div>
        </section>

        {/* Kursübersicht nach Kategorien & Jahren */}
        <section>
          <h2 className="text-2xl font-semibold text-gray-800 mb-6 flex items-center gap-2">
            <span className="text-3xl">📚</span> Bisherige Kurse
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {courseSections.map((section, idx) => (
              <div
                key={idx}
                className="mb-6 p-6 bg-white rounded-xl shadow-lg hover:shadow-xl transition-all duration-300 border border-blue-50"
              >
                <h3 className="text-xl font-bold text-gray-700 mb-4">
                  {section.title}
                </h3>
                {Object.entries(section.courses)
                  .sort(
                    ([yearA], [yearB]) =>
                      Number(yearB) - Number(yearA)
                  )
                  .map(([year, yearCourses]) => (
                    <div key={year} className="mb-6 last:mb-0">
                      <p className="text-md text-blue-600 font-semibold mb-2">
                        Jahr: {year}
                      </p>
                      <ul className="space-y-3">
                        {yearCourses.map((course, i) => (
                          <li
                            key={i}
                            className="hover:translate-x-2 transition-transform duration-200"
                          >
                            <a
                              href={course.url}
                              className="text-gray-700 hover:text-blue-600 flex items-center gap-2 text-base md:text-lg"
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              <span className="text-blue-500">▸</span>
                              {course.title}
                              {course.url && (
                                <svg
                                  className="inline-block w-4 h-4 ml-2 text-blue-500"
                                  fill="none"
                                  stroke="currentColor"
                                  viewBox="0 0 24 24"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    strokeWidth="2"
                                    d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14"
                                  />
                                </svg>
                              )}
                            </a>
                          </li>
                        ))}
                      </ul>
                    </div>
                  ))}
              </div>
            ))}
          </div>
        </section>
      </div>
      <div className="mt-16">
        <h2 className="text-2xl font-bold text-center text-main mb-6">
          Eindrücke aus unseren Kursen
        </h2>
        <div className="flex flex-wrap justify-center gap-4">
          <img
            src={arduinoImage1}
            alt="Roboter"
            className="w-full sm:w-48 rounded-lg shadow-md object-cover"
          />
          <img
            src={arduinoImage0}
            alt="Arduino Board"
            className="w-full sm:w-48 rounded-lg shadow-md object-cover"
          />

          <img
            src={kidsImage}
            alt="Kinder am PC"
            className="w-full sm:w-48 rounded-lg shadow-md object-cover"
          />
          <img
            src={scratchImage}
            alt="Scratch Logo"
            className="w-full sm:w-48 rounded-lg shadow-md object-contain bg-white p-2"
          />
        </div>
      </div>

      <AnnourFooter />
    </div>
  );
};

export default ProgrammingCoursesPage;
